import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
count =0;
  constructor(
    // private countService:CountService
  ) { }

  ngOnInit(): void {
    // this.countService.countChange.subscribe(count=>{
    //   this.count = count;
    // })
  }
}
